export default [
  {
    path: '/learning-center/report',
    name: 'report',
    component: () => import('@/views/learning/report/LearningReport.vue'),
  },
];
